import { useContext } from 'react'

import { RequestProfileContext } from '../../RequestProfile.context'

export function useRequestProfileContext() {
  return useContext(RequestProfileContext)
}
